const REQUIRED_VARS = ["REACT_APP_BASE_URL"];

export function checkEnv() {
  const missing = REQUIRED_VARS.filter((key) => !process.env[key]);

  if (missing.length > 0) {
    const msg = `Missing required environment variables: ${missing.join(", ")}`;
    if (process.env.NODE_ENV === "production") {
      throw new Error(msg);
    }
    console.warn(`[envCheck] ${msg}`);
  }

  if (process.env.NODE_ENV === "production") {
    const baseUrl = process.env.REACT_APP_BASE_URL || "";
    if (!baseUrl.startsWith("https://")) {
      throw new Error(
        `REACT_APP_BASE_URL must use https:// in production. Got: ${baseUrl}`
      );
    }
  }
}
